/**
 * Api error codes that are reported by the User Group controller
 */
export var UserGroupErrorCode;
(function (UserGroupErrorCode) {
    /**
     * Indicates an attempt to create a User Group that violates a uniqueness constraints within a Court System
     */
    UserGroupErrorCode["UserGroupNameAlreadyExist"] = "user-group/UserGroupNameAlreadyExist";
    /**
     * Represents a failed attempt at removing a user group
     */
    UserGroupErrorCode["CouldNotRemoveUserGroup"] = "user-group/CouldNotRemoveUserGroup";
    /**
     * Represents a failed attempt at removing a user from a user group
     */
    UserGroupErrorCode["CouldNotRemoveLastAdminUserFromCourtSystem"] = "user-group/CouldNotRemoveLastAdminUserFromCourtSystem";
})(UserGroupErrorCode || (UserGroupErrorCode = {}));
